// extracted by mini-css-extract-plugin
export default {"title":"StageTitle_title__VNxpC","small":"StageTitle_small__K0qeM"};